import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

export const ConfirmDelete = ({ onConfirm, label, description, testId, small }) => {
  const [busy, setBusy] = useState(false);
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          data-testid={testId}
          className={
            small
              ? "text-[#6D726A] hover:text-[#0E6B3A] transition-colors p-1.5"
              : "inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#6D726A] hover:text-[#0E6B3A] transition-colors"
          }
          title={label}
        >
          <Trash2 className="w-4 h-4" strokeWidth={1.6} />
          {!small && label}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-[#FBF7F0] border-[#8E1226]/10">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-2xl text-[#8E1226]">
            {label}?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#6D726A]">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full">Keep it</AlertDialogCancel>
          <AlertDialogAction
            data-testid={`${testId}-confirm`}
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              await onConfirm();
              setBusy(false);
            }}
            className="rounded-full bg-[#0E6B3A] hover:bg-[#083D21] text-[#FBF7F0]"
          >
            Yes, delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
